module.exports = __webpack_public_path__ + "img/data-storage.8ee9e64f.png";